<template>
  <div>
    <div class="m-edition-section-content-subject m-edition-map-tasks">
      <blockquote
        v-if="!nodes.length"
        class="quote quote-maps-primary quote-first"
      >
        <p>
          <span>
            {{ $t('mEditionMapTasks.quote.firstText') }}
            {{ $t('mEditionMapTasks.quote.secondText') }}
            <router-link
              :to="`/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.path.subject')}`"
              class="text-color-maps-primary"
            >
              {{ $t('mEditionMenu.map.path.text') }}.
            </router-link>
          </span>
        </p>
      </blockquote>

      <div
        v-if="nodes.length"
        class="m-edition-section-content-subject-split-edition"
      >
        <div class="m-edition-section-content-subject-split-edition-item-left">
          <MoleculeEditionMapTasksList :should-read-tasks-list="shouldReadTasksList"/>
        </div>
        <div class="m-edition-section-content-subject-split-edition-item-right">
          <MoleculeEditionMapTasksRecord @readTasksList="readTasksList" />
          <MoleculeContentNode v-show="false" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapTasks',

  components: {
    MoleculeEditionMapTasksList: () => import('@/components/molecules/MoleculeEditionMapTasksList'),
    MoleculeEditionMapTasksRecord: () => import('@/components/molecules/MoleculeEditionMapTasksRecord'),
    MoleculeContentNode: () => import('@/components/molecules/MoleculeContentNode')
  },

  data () {
    return {
      nodes: [],
      shouldReadTasksList: null,
      tasks: []
    }
  },

  created () {
    this.nodes = [...this.$store.getters.getAssetNodes]
  },

  methods: {
    readTasksList () {
      this.shouldReadTasksList = Date.now()
    }
  }
}
</script>
